import React, { Component } from 'react';
import Storages from 'storages';
import Carousel from 'components/common/carousel/carousel';
import StorageKeys from 'enum/storages.enum';
import EventBus from 'utils/eventBus';
import { subscribeImageSrc } from 'utils/cache/imageResolver';

const REBUILD_DEBOUNCE_MS = 50;

class wallpapers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      carouselData: [],
      sliderTimer: 60,
      carouselKey: Date.now(),
    };

    this.eventSubscriptions = [];
    this.imageUnsubscribes = [];
    this.resolvedMap = new Map();
    this.currentRawUrls = [];
    this.rebuildTimer = null;
  }

  componentDidMount() {
    this.eventSubscriptions.push(
      EventBus.subscribe('refresh', this.getDisplayWallpaper.bind(this))
    );
    this.getDisplayWallpaper();
  }

  componentWillUnmount() {
    this.eventSubscriptions.forEach((s) => s.unsubscribe());
    this.teardownImageSubscriptions();
    if (this.rebuildTimer) {
      clearTimeout(this.rebuildTimer);
      this.rebuildTimer = null;
    }
  }

  teardownImageSubscriptions() {
    this.imageUnsubscribes.forEach((u) => u());
    this.imageUnsubscribes = [];
    this.resolvedMap.clear();
  }

  /**
   * Coalesces bursty subscription callbacks (typical during initial resolve
   * or after the 50-min periodic refresh) into a single carousel update so
   * react-carousel-minimal does not remount on every individual image resolve.
   */
  scheduleRebuild() {
    if (this.rebuildTimer) return;
    this.rebuildTimer = setTimeout(() => {
      this.rebuildTimer = null;
      this.rebuildCarousel();
    }, REBUILD_DEBOUNCE_MS);
  }

  rebuildCarousel() {
    const data = this.currentRawUrls
      .map((rawUrl) => ({ image: this.resolvedMap.get(rawUrl), caption: '' }))
      .filter((item) => !!item.image);

    const prev = this.state.carouselData;
    const sameLength = data.length === prev.length;
    const sameImages = sameLength && data.every((item, i) => item.image === prev[i].image);
    if (sameImages) return;

    this.setState({ carouselData: data, carouselKey: Date.now() });
  }

  getDisplayWallpaper() {
    const grpWallpapers = Storages.getGroupWallpapers();
    const sliderTimerData = Storages.MainStorage.getItem(StorageKeys.Keys.SLIDERTIMER);
    const sliderTimer = sliderTimerData?.slideshow_timer ?? this.state.sliderTimer;

    this.teardownImageSubscriptions();
    this.currentRawUrls = grpWallpapers.map((e) => e.image).filter(Boolean);
    this.setState({ sliderTimer });

    this.imageUnsubscribes = this.currentRawUrls.map((rawUrl) =>
      subscribeImageSrc(rawUrl, (src) => {
        this.resolvedMap.set(rawUrl, src);
        this.scheduleRebuild();
      })
    );
  }

  render() {
    return (
      <>
        <Carousel
          key={this.state.carouselKey}
          carouselData={this.state.carouselData}
          sliderTimer={this.state.sliderTimer}
        ></Carousel>
      </>
    );
  }
}

export default wallpapers;
